import { render, staticRenderFns } from "./turnoRutas.vue?vue&type=template&id=2a4b6f61&scoped=true&"
import script from "./turnoRutas.vue?vue&type=script&lang=js&"
export * from "./turnoRutas.vue?vue&type=script&lang=js&"
import style0 from "./turnoRutas.vue?vue&type=style&index=0&id=2a4b6f61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b6f61",
  null
  
)

export default component.exports